import { Col } from "reactstrap";
import ButtonPackage from "../Button/PackageButton";

function TableChildPackage({ pkg, handleClick, buttonText = "Pilih Paket" }) {
    return (
        <>
            <Col lg="3" md="6" key={pkg.id}>
                <div
                    className={`landing-package-card ${pkg.featured ? "featured" : ""}`}
                >
                    {/* <div className="landing-package-badge">{pkg.badge || "Internet"}</div> */}
                    <h4>{pkg.name}</h4>
                    <h2>{pkg.speed}</h2>
                    <p className="landing-package-price">{pkg.price}</p>
                    <p className="landing-package-devices">{pkg.devices}</p>
                    <ul>
                    {pkg.features.map((feat, idx) => (
                        <li key={idx}>
                            <i className="fa fa-check" /> {feat}
                        </li>
                    ))}
                    </ul>
                    <ButtonPackage
                        onClick={() => handleClick ? handleClick(pkg) : undefined}
                        title={buttonText}
                    />
                </div>
            </Col>
        </>
    );
}

export default TableChildPackage;
